import React from 'react';
import "./Business.css";
import Logo from "../Util/Logo";
import Button from "../Util/Button";

import { ReactComponent as Building } from "../assets/icons/handshake.svg"; 

const BusinessServices = () => {
    return (
        <div className='business-services'>

            <section className='hero-section'>
                <div className='hero-content'>
                    <div className='brand-tag'>
                        <Logo/>
                    </div>
                    <h1>德国商务与投资 <br/> <span>协助拓展德国和欧洲市场</span></h1>
                    <p className='hero-desc'>
                        醒狮中德商联（SINIS GmbH） 总部位于德国经济核心区——慕尼黑南部，地理位置优越，交通便利。凭借25年行业经验及精通中、德、英三语的专业团队，我们为中国企业在德国的市场拓展提供全方位、一站式的综合服务，助力企业高效进入欧洲市场。
                    </p>
                    <Button to="/contact">联系我们</Button>
                </div>
                <div className='hero-visual'>
                    <img src="./images/preperation-for-your-china-trip.webp" alt="" loading="eager" decoding="async" />
                    <div className='overlay'></div>
                </div>
            </section>

            <section className='mission-section'>
                <div className='container'>
                    <div className='section-title'>
                        <h2>我们的使命</h2>
                        <div className='line'></div>
                    </div>
                    <p className='mission-text'>
                        我们致力于推动中欧经贸合作，不仅帮助欧洲企业对接中国市场，更助力中国企业拓展欧洲业务。依托在中欧两地稳固的经济网络，我们提供双向投资咨询、市场拓展及全方位商务支持。
                    </p>
                </div>
            </section>

            <section className='services-grid-section'>
                <div className='container'>
                    <div className='section-title'>
                        <h2>核心服务范围</h2>
                    </div>
                    <div className='services-container'>
                        <div className='service-item'>
                            <span className='num'>01</span>
                            <h3>企业落地支持</h3>
                            <p>协助在德设立公司、子公司或代表处，确保合规注册及顺利落地。</p>
                        </div>
                        <div className='service-item'>
                            <span className='num'>02</span>
                            <h3>商务基础设施</h3>
                            <p>提供注册地址、共享服务中心及公司托管，有效降低初期运营成本。</p>
                        </div>
                        <div className='service-item'>
                            <span className='num'>03</span>
                            <h3>投资咨询</h3>
                            <p>提供市场分析、战略规划及投资风险评估，助力精准布局欧洲市场。</p>
                        </div>
                        <div className='service-item'>
                            <span className='num'>04</span>
                            <h3>项目招商会组织</h3>
                            <p>策划并组织各类招商推介会，精准对接德国本地政府与行业资源。</p>
                        </div>
                        <div className='service-item'>
                            <span className='num'>05</span>
                            <h3>国际展会支持</h3>
                            <p>涵盖展位申请、搭建、品牌推广及展中商务对接全流程服务。</p>
                        </div>
                        <div className='service-item'>
                            <span className='num'>06</span>
                            <h3>欧盟商标注册</h3>
                            <p>专业办理德国及EU商标注册，为品牌出海提供强有力的法律保护。</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='trademark-section'>
                <div className='container'>
                    <div className='tm-card'>
                        <h2>欧盟商标注册 (EUTM)</h2>
                        <p>覆盖27个成员国，一次申请，全欧受保护。我们拥有15年以上的知识产权服务经验。</p>
                        <div className='tm-steps'>
                            <div className='step'>1. 商标检索</div>
                            <div className='arrow'>→</div>
                            <div className='step'>2. 递交申请</div>
                            <div className='arrow'>→</div>
                            <div className='step'>3. 形式审查</div>
                            <div className='arrow'>→</div>
                            <div className='step'>4. 公告与注册</div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='feature-section'>

                <div className='img-wrapper'>
                    <img src="./images/choose-sinis.webp" alt="" loading="lazy" decoding="async" />
                </div>
                
                <div className='text-wrapper'>
                    <div className='txt'>
                        <p className='question'>领航中欧，共赢未来：为什么选择醒狮中德商联？</p>
                        <p>在充满机遇与挑战的德国市场，您需要的不仅仅是一个服务商，更是一个深谙中德商业逻辑的战略伙伴。醒狮中德商联（SINIS GmbH） 凭借25年的行业积淀，将德国的严谨合规与中国的效率速度完美结合。</p>
                        <p>我们深知中国企业“出海”的痛点，从公司设立到品牌保护，从商务落地到投资咨询，我们为您扫平一切文化与法律障碍。选择醒狮，就是选择了一条通往欧洲市场的“快车道”。让我们助您的事业在欧洲版图上行稳致远，成就全球品牌巅峰。</p>
                        <Button to={"/contact"}>立即咨询，开启您的德国事业新篇章</Button>
                    </div>
                </div>
            </section>

            <section className='commitment-section'>
                <div className='container'>
                    <div className='stats-bar'>
                        <div className='stat'><strong>25年+</strong> <span>行业经验</span></div>
                        <div className='stat'><strong>中德英</strong> <span>三语支持</span></div>
                        <div className='stat'><strong>100%</strong> <span>全流程合规</span></div>
                    </div>
                    <Button to={"/contact"} filled>联系我们</Button>
                </div>
            </section>
        </div>
    );
};

export default BusinessServices;